import React from 'react';
import StreamPreview from './StreamPreview.jsx';

class StreamerResume extends React.Component {
	render () {
		// On créé une variable qui contient le nom du jeu
		let gameName = 'aucun jeu';

		if (typeof this.props.game !== 'undefined') {
			gameName = this.props.game.name;
		}

		return (
			<div className="col txtmiddle">
				<div className="row row-mobile">
					<div className="col txtmiddle col-mobile">
						<h3 className="man proxima-bold capitalize">
							{this.props.isLoading &&
								<mark className="pan">
									&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								</mark>
							}

							{this.props.isLoading !== true &&
								this.props.streamerName
							}
						</h3>


						{this.props.isLoading &&
							<p className="man">
								<mark className="pan">
									&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								</mark>
							</p>
						}

						{(this.props.streamURL !== false && this.props.streamURL !== null) &&
							<p className="man">
								Joue à&nbsp;
								<a href={this.props.streamURL} 
									target="_blank" 
									className="proxima-bold">
									{gameName}
								</a> 
								&nbsp;devant&nbsp;
								<span className="proxima-bold">
									{this.props.viewers}
								</span> 
								&nbsp;donateurs
							</p>
						}
					</div>

					{(this.props.streamURL !== false || this.props.isLoading) &&
						<StreamPreview streamURL={this.props.streamURL}
							streamPreviewImg={this.props.streamPreviewImg}
							isLoading={this.props.isLoading} />
					}
				</div>
			</div>
		);
	}
}

export default StreamerResume;